import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay, throttleTime } from 'rxjs/operators';
import { CommitmentsForCompanyResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class CommitmentService {
  private weeklyCommitments$$ = new BehaviorSubject<CommitmentsForCompanyResponse>(null);
  private weeklyCommitmentsThrottle$$ = new Subject();
  private weeklyCommitmentsShared$ = this.weeklyCommitments$$.pipe(shareReplay(1));
  public get weeklyCommitments$(): Observable<CommitmentsForCompanyResponse> {
    this.weeklyCommitmentsThrottle$$.next();
    return this.weeklyCommitmentsShared$;
  }

  constructor(private httpClient: HttpClient, private logger: NGXLogger) {
    this.weeklyCommitmentsThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadWeeklyCommitments();
    });
  }

  public async updateWeeklyCommitment(
    responses: { requestId: number; concurrentDriverCount: number }[],
  ): Promise<boolean> {
    try {
      const result = await this.httpClient
        .post<CommitmentsForCompanyResponse>(`${environment.api}/v1/admin/commitments`, { responses })
        .toPromise();
      this.weeklyCommitments$$.next(result);
      return true;
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }

  private async loadWeeklyCommitments() {
    try {
      const result = await this.httpClient
        .get<CommitmentsForCompanyResponse>(`${environment.api}/v1/admin/commitments`)
        .toPromise();
      this.weeklyCommitments$$.next(result);
    } catch (error) {
      this.logger.error(error);
    }
  }
}
